export const DATE_TEXT = {
  JUST_NOW: 'Just now',
} as const
